import React from "react"
import { connect } from "react-redux"
import * as agents from "../actions/agents"
import {
    callFinish,
    callStart,
    setDialIn,
    setHangup,
    setHideSoftphone,
    setSoftphoneError,
    setSoftphoneRegistered,
} from "../actions/softphone"
import * as actions from "../actions/websocket"
import toast from "../misc/Toast"
import Softphone from "../softphone/Softphone"

class SoftphoneWrapper extends React.PureComponent {
    constructor(props) {
        super(props)
        this.messageCallback = this.onMessage.bind(this)
        this.statusCallback = this.onConnected.bind(this)
        this.silence = React.createRef()
        this.state = {
            visible: false,
            intransfer: false,
            registered: false,
            call: {},
            headers: [],
            connection: true, //!!this.props.bargeIn,
            dialingcall: false,
            callableChecked: false,

            credentials: {
                ext: "",
                pwd: "",
                server: "",
            },
        }
    }

    handleClick = e => {
        if (this.silence.current) {
            this.silence.current.play()
        }
        window.removeEventListener("click", this.handleClick)
    }

    componentDidMount = () => {
        this.mounted = true
        this.isSafari =
            !!navigator.userAgent.match("Safari/") &&
            !navigator.userAgent.match("Chrome/") &&
            !navigator.userAgent.match("Chromium/")

        this.requestWakeLock()
        this.props.dispatch(actions.subscribe(this.messageCallback, this.statusCallback))
        // this.reloadCalls();
        window.addEventListener("click", this.handleClick)
    }

    componentWillUnmount = () => {
        this.props.dispatch(actions.unsubscribe(this.messageCallback, this.statusCallback))
        window.removeEventListener("click", this.handleClick)
        this.mounted = false
        this.releaseWakeLock()
    }

    onMessage = (conn, cmd, data) => {
        switch (cmd) {
            case "call":
                this.setupCall(data)
                break
            case "originate_error":
                this.props.dispatch(callFinish())
                this.setState({ visible: this.state.oldvisible, intransfer: null })
                // this.reloadCalls();
                this.setState({ call: {} })
                toast.error(data)
                this.props.dispatch(setSoftphoneError(data))
                break
            default:
        }
    }

    onConnected = connected => {
        this.setState({ connection: connected })
    }

    setupCall = call => {
        if (call) {
            this.setState({ call: call })
        }
    }

    handleHide = () => {
        this.setState({ visible: false })
    }

    handleIncomingCall = number => {
        this.props.dispatch(callStart(number))

        if (number !== "asterisk") {
            this.props.dispatch(agents.getContact(number))
        }

        this.setState({ visible: true, oldvisible: this.state.visible })
        // this.reloadCalls();
    }

    handleOutgoingCall = (contact, callerid, extra) => {
        this.setState({ visible: true, oldvisible: this.state.visible })
        let number = ""
        if (typeof contact === "string") {
            number = contact
        } else if (contact?.phonenumber) {
            number = contact.phonenumber
        } else if (number === "") {
            return false
        }

        this.props.dispatch(callStart(number))

        if (!extra) {
            if (contact?.phonenumber) {
                this.props.dispatch(agents.createOrUpdateContact(JSON.stringify(contact)))
            } else {
                this.props.dispatch(agents.getContact(number))
            }

            const data = {
                number: number,
                campaignid: null, //2057
                callerid: callerid,
            }
            if (this.props.postbackURL) {
                data.postback = this.props.postbackURL
            }
            this.props.dispatch(actions.send("originate", data))
        } else {
            this.props.dispatch(actions.send("originate_full", extra))
        }
        // this.reloadCalls();
        return true
    }

    handleHangup = () => {
        this.props.dispatch(actions.send("hangup", ""))
        this.props.dispatch(callFinish())
        this.setState({ visible: false, intransfer: null })
        // this.reloadCalls();
        this.setState({ call: {} })
        this.props.dispatch(setHideSoftphone())
        this.props.dispatch(agents.setContact(null))
        this.props.dispatch(setDialIn({}))
        this.props.dispatch(setHangup(false))
    }

    handleDoHangup = () => {
        this.handleHangup()
    }

    handleDestroy = () => {
        this.props.dispatch(actions.disconnect())
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps.contact !== this.props.contact && this.props.contact) {
            this.setState({
                visible: true,
                contact: {
                    name: `${this.props.contact.get("firstname")} ${this.props.contact.get("lastname")}` || "",
                    phonenumber: this.props.contact.get("phonenumber") || "",
                },
            })
            // if (this.props.contact && this.props.contact.get("id")) {
            //   this.props.dispatch(
            //     push(`/contacts/view/${this.props.contact.get("id")}`)
            //   );
            // }
        }
        if (prevProps.show !== this.props.show) {
            this.setState({
                visible: this.props.show,
            })
        }

        if (prevProps.hangup !== this.props.hangup && this.props.hangup) {
            this.handleHangup()
        }

        if (prevProps.destroy !== this.props.destroy && this.props.destroy) {
            this.handleDestroy()
        }

        if (prevProps.auth !== this.props.auth && this.props.auth) {
            this.setState({
                credentials: {
                    ext: this.props.sipCredentials.login,
                    pwd: this.props.sipCredentials.pwd,
                    server: this.props.sipServers[0],
                },
            })
        }
    }

    requestWakeLock = async () => {
        try {
            this.wakeLock = await navigator.wakeLock.request("screen")
            this.wakeLock.addEventListener("release", () => {
                console.log("Wake Lock was released")
            })
            console.log("Wake Lock is active")
        } catch (err) {
            console.error(`${err.name}, ${err.message}`)
        }
    }

    releaseWakeLock = async () => {
        if (!this.wakeLock) {
            return
        }
        try {
            await this.wakeLock.release()
            this.wakeLock = null
        } catch (err) {
            console.error(`${err.name}, ${err.message}`)
        }
    }

    handleChangeState = state => {
        this.setState({ registered: state })
    }

    handleSoftphoneRegister = () => {
        this.props.dispatch(setSoftphoneRegistered(true))
    }

    render() {
        if (this.props.destroy) return ""
        return (
            <>
                <audio ref={this.silence} autoPlay loop>
                    <source src="https://app.batchdialer.com/audio/silence.mp3" type="audio/mpeg" />
                </audio>
                {this.props.auth && this.state.credentials?.ext !== "" && (
                    <Softphone
                        connection={this.state.connection}
                        onSoftphoneRegister={this.handleSoftphoneRegister}
                        onIncomingCall={this.handleIncomingCall}
                        onOutgoingCall={this.handleOutgoingCall}
                        onHangup={this.handleHangup}
                        onDoHangup={this.handleDoHangup}
                        onChangeState={this.handleChangeState}
                        onHide={this.handleHide}
                        visible={this.state.visible}
                        contact={this.state.contact}
                        call={this.state.call}
                        credentials={this.state.credentials}
                        headers={this.state.headers}
                        qualityMonitor={this.props.qualityMonitor}
                        iceServers={this.props.iceServers}
                        sipServers={this.props.sipServers}
                        dial={this.props.dial}
                        eventHandler={this.props.eventHandler}
                        options={this.props.options}
                        transcriptionEnabled={this.props.transcriptionEnabled}
                        dispatch={this.props.dispatch}
                    />
                )}
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        contact: state.agent.get("contact"),
        agent: state.agent,
        auth: state.softphone?.get("auth"),
        dial: state.softphone?.get("dial"),
        hangup: state.softphone?.get("hangup"),
        destroy: state.softphone?.get("destroy"),
        iceServers: state.softphone?.get("iceServers"),
        sipServers: state.softphone?.get("sipServers"),
        sipCredentials: state.softphone?.get("sipCredentials"),
        postbackURL: state.softphone?.get("postbackURL"),
        show: state.softphone?.get("show"),
        options: state.options,
        transcriptionEnabled: state.callIntelligence?.subscribed,
    }
}

export default connect(mapStateToProps)(SoftphoneWrapper)
